import $ from "jquery";
import typeahead from "corejs-typeahead";
import FuzzySearch from "fz-search";

$(function () {
	const submitOrder = (e) => {
		e.preventDefault();
		const tableBody = document.getElementById("QuickOrderTableBody").children;
		const rows = [...tableBody];
		const promises = [];
		rows.forEach((row, index) => {
			const product = {
				id: row.dataset.productid,
				quantity: row.dataset.quantity,
			};
			promises.push(
				$.ajax({
					url: `/?add-to-cart=${product.id}&quantity=${product.quantity}`,
					type: "GET",
					success: (data) => {
						return `Product ${product.id} (${product.quantity}) added to cart`;
					},
					error: (err) => {
						return err;
					},
				})
			);
		});
		(async function () {
			for (const asyncFn of promises) {
				const result = await asyncFn();
				console.log(result);
			}
		})();
	};
	$("#submitOrder").on("click", submitOrder);
	const addToOrder = (e) => {
		e.preventDefault();
		$("#QuickOrderTableBody").append(
			`<tr data-productId="${$(".tt-input").attr(
				"data-id"
			)}" data-quantity="${$("#quantity1").val()}" ><td>${$(
				".tt-input"
			).val()}</td>
			<td>${$("#quantity1").val()}</td>
			<td><button id="addToCart${$(".tt-input").attr(
				"data-id"
			)}" class="button">Add item to cart</button></td>
			</tr>`
		);
		$("[id^=addToCart]").on("click", (e) => {
			e.preventDefault();
			// get data from the TR element
			const tr = e.target.parentElement.parentElement;
			const productId = tr.dataset.productid;
			const quantity = tr.dataset.quantity;
			const addToCartUrl = `/?add-to-cart=${productId}&quantity=${quantity}`;
			$.ajax({
				url: addToCartUrl,
				type: "GET",
				success: (data) => {
					console.log("Success");
				},
				error: (err) => {
					console.log(err);
				},
			});
		});
	};
	$("#addToOrder").on("click", addToOrder);

	const products = JSON.parse(localStorage.getItem("products"));
	const fuzzyhound = new FuzzySearch({
		source: products,
		keys: ["sku", "id"],
	});
	$(".typeahead").typeahead(
		{ minLenght: 2, highlight: false },
		{
			name: "skus",
			source: fuzzyhound,
			templates: {
				suggestion: function (result) {
					return "<div>" + fuzzyhound.highlight(result.sku) + "</div>";
				},
			},
		}
	);
	$(".typeahead").bind("typeahead:select", function (ev, suggestion) {
		$(".typeahead").typeahead("val", suggestion.sku);
		$(".tt-input").attr("data-id", suggestion.id);
	});
});
